import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "container wow animate__animated animate__fadeInRight",
  "data-wow-duration": "2s"
};
const _hoisted_2 = {
  class: "list"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "item-title"
};
const _hoisted_5 = {
  class: "item-content"
};
import { onMounted, nextTick } from "vue";
import { WOW } from 'wowjs';
import "animate.css";
import icon1 from '@/assets/icon1.png';
import icon2 from '@/assets/icon2.png';
import icon3 from '@/assets/icon3.png';
import icon4 from '@/assets/icon4.png';
import icon5 from '@/assets/icon5.png';
import icon6 from '@/assets/icon6.png';
import icon7 from '@/assets/icon7.png';
import icon8 from '@/assets/icon8.png';
export default {
  __name: 'index',
  setup(__props) {
    const list = [{
      img: icon1,
      title: '精细化发券',
      content: '根据各省市及下属的各市、县、区、各部门不同的业务需求，个性化开发了各种发券功能与核销逻辑。'
    }, {
      img: icon2,
      title: '攻略化促销',
      content: '整合不同部门、不同规则的政企合力券种，开展促消费长链攻略推介：引导用户吃、娱、住、行一体多维消费。'
    }, {
      img: icon3,
      title: '立体化风控',
      content: '78个维度开启订单实时侦测和拦截，针对商家用户异常情况进行立体监控，实时分秒级多维度刷单、套现预警。'
    }, {
      img: icon4,
      title: '资金安全保障',
      content: '与各省市国资公司成立混改公司，所有消费券发放资金进入国资公司在银行开设的政府封闭监管账户。'
    }, {
      img: icon5,
      title: '数据安全保障',
      content: '各省市的促消费数据只留本地，系统采用高等级的数据完全保护插件，数据明细调取需要相关部门同意并附调取函。'
    }, {
      img: icon6,
      title: '应急预案保障',
      content: '企业级数据库服务器，应对异常突发的访问数据并发过载，专业运维团队，24小时应急备战。'
    }, {
      img: icon7,
      title: '核销精准保障',
      content: '三端一舱一脑实时数据分析，各维度数据一一对应，多端相佐证对账，按审计要求实时对账，做到审计数据无差错。'
    }, {
      img: icon8,
      title: '数据分析保障',
      content: '先进的大数据分析技术，对各市、县、区的促消费数据进行实时全面分析并专人汇报。'
    }];
    onMounted(() => {
      //初始化wow.js(页面滚动加载动画)
      nextTick(() => {
        //页面渲染完，在执行
        let wow = new WOW({
          live: false
        });
        wow.init();
      });
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "us-title"
      }, "SERVICE AND GUARANTEE", -1)), _cache[2] || (_cache[2] = _createElementVNode("h3", {
        class: "title"
      }, "服务与保障", -1)), _createElementVNode("div", _hoisted_2, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(list, item => {
        return _createElementVNode("div", {
          class: "list-item",
          key: item.title
        }, [_createElementVNode("img", {
          src: item.img,
          style: {
            "width": "30px",
            "height": "30px"
          },
          alt: ""
        }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, _toDisplayString(item.title), 1), _cache[0] || (_cache[0] = _createElementVNode("div", {
          class: "red-bd"
        }, null, -1)), _createElementVNode("div", _hoisted_5, _toDisplayString(item.content), 1)]);
      }), 64))])]);
    };
  }
};